'use client'

import React, { createContext, useContext, useState, ReactNode, useEffect } from 'react';
import { usePathname } from 'next/navigation';

interface SEOState {
  title?: string;
  description?: string;
  canonical?: string;
  ogImage?: string;
  noindex?: boolean;
}

interface SEOContextType extends SEOState {
  updateSEO: (seo: Partial<SEOState>) => void;
}

const SEOContext = createContext<SEOContextType | undefined>(undefined);

export const useSEOContext = () => {
  const context = useContext(SEOContext);
  if (!context) {
    throw new Error('useSEOContext must be used within SEOProvider');
  }
  return context;
};

interface SEOProviderProps {
  children: ReactNode;
}

export const SEOProvider: React.FC<SEOProviderProps> = ({ children }) => {
  const pathname = usePathname();
  const [seoState, setSeoState] = useState<SEOState>({});

  const updateSEO = (newSEO: Partial<SEOState>) => {
    setSeoState(prev => ({ ...prev, ...newSEO }));
  };

  // Reset SEO state when route changes
  useEffect(() => {
    setSeoState({});
  }, [pathname]);

  return (
    <SEOContext.Provider value={{
      ...seoState,
      updateSEO
    }}>
      {children}
    </SEOContext.Provider>
  );
};

export default SEOProvider; 